import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Neighborhood } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class NeighborhoodModule extends VuexModule {
    @Action
    [Neighborhood.getNeighborhoodList]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/neighborhood/list`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Neighborhood.findPageNeighborhood](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/neighborhood/show`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Neighborhood.saveNeighborhood](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/neighborhood/save`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Neighborhood.deleteNeighborhood](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/neighborhood/delete`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Neighborhood.getManagers]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/neighborhood/getManagers`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}